export const SET_ADDRESS = 'SET_ADDRESS';
export const REQUIRE_SHIPPING = 'REQUIRE_SHIPPING';
export const SET_AVAILABILITY = 'SET_AVAILABILITY';
export const LOAD_VENDOR = 'LOAD_VENDOR';
export const SET_VENDOR = 'SET_VENDOR';

import Promise from 'bluebird';
import Cookies from 'universal-cookie';
import { request, availability, vendor } from 'shared/models/api';
import { cartRequest } from 'shared/models/cart';
import Parse from 'parse';
import { setVendor as setCheckoutVendor } from 'components/checkoutPage/actions';
import {
  restore as restoreCart,
  refreshShippingOptions
} from 'components/cart/actions';
import { getCurations } from 'components/storefront/actions';
import { loadAvailableCategories } from 'components/categoryLink/actions';
import { trackNow } from 'shared/models/analytic';

const initialState = {};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_ADDRESS:
      return { ...action.location };
    case LOAD_VENDOR:
      return { ...state, loadingVendor: true };
    case SET_VENDOR:
      return { ...state, vendor: action.vendor, loadingVendor: false };
    case REQUIRE_SHIPPING:
      return { ...state, shipping: action.shipping };
    case SET_AVAILABILITY:
      return { ...state, availability: action.availability };
    default:
      return state;
  }
}

function persist(state) {
  const cookies = new Cookies();
  cookies.set('address', state, { path: '/', expires: new Date('01/01/2030') });
}

export function setRequestQueries(location) {
  if (location.lat && location.lng) {
    cartRequest.query({ lat: location.lat, lng: location.lng });
    request.query({ lat: location.lat, lng: location.lng });
  }
  if (location.zip) {
    if (!location.address) {
      request.query({ zip: location.zip });
    } else {
      request.query({ zip: null });
    }
  }
}

// TODO: move action dispatches to relevant components
export function setAddress(address, opts = {}) {
  return (dispatch, getState) => {
    if (!address) return Promise.resolve();
    persist(address);
    setRequestQueries(address);
    dispatch({ type: SET_ADDRESS, location: address });
    const restoreCartPromise = getState().cart.products.length
      ? dispatch(restoreCart())
      : Promise.resolve();
    if (getState().storefront.curations.length) dispatch(getCurations());
    dispatch(loadAvailableCategories());
    return dispatch(loadVendor()).then(result => {
      if (!result) return null;
      if (opts.checkout) dispatch(setCheckoutVendor(result));
      if (typeof result.shipping !== 'undefined') {
        dispatch({ type: REQUIRE_SHIPPING, shipping: result.shipping });
        persist({ ...address, shipping: result.shipping });
        if (opts.checkout && result.shipping) {
          restoreCartPromise.then(() => dispatch(refreshShippingOptions()));
        }
      }
      var storeId =
        result.banner._id === 'out_of_zone' ? 'scy' : result.store_id;
      let trackingParams = { storeID: storeId };
      if (opts.page) trackingParams.page = opts.page;
      if (opts.source) trackingParams.source = opts.source;
      trackNow('Delivery Address Set', trackingParams);
      let user = Parse.User.current();
      if (user) {
        const updatedAddress = getState().address;
        user.set(
          'lastLocation',
          new Parse.GeoPoint({
            latitude: updatedAddress.lat,
            longitude: updatedAddress.lng
          })
        );
        user.save();
      }
      return result;
    });
  };
}

export function loadVendor() {
  return (dispatch, getState) => {
    if (getState().address.loadingVendor) return Promise.resolve();
    dispatch({ type: LOAD_VENDOR });
    return vendor().then(result => {
      dispatch({ type: SET_VENDOR, vendor: result });
      return result;
    });
  };
}

export function getAvailability() {
  return dispatch => {
    return availability().then(availability => {
      dispatch({ type: SET_AVAILABILITY, availability });
    });
  };
}
